import { PageTypes } from '..';
import Platform from '..';
import { PlatformAssetWrapperMap } from '..';
import { PageNotReady } from '../../errors';
import { OlWarning } from '../../events';
import { HollerWPSrpAssetWrapper } from './srp-wrapper';
import { HollerWPVdpAssetWrapper } from './vdp-wrapper';

/**
 * Holler WordPress platform class
 */
export default class HollerWPPlatform extends Platform {
  pageTypeMap: PlatformAssetWrapperMap = {
    [PageTypes.SRP]: HollerWPSrpAssetWrapper,
    [PageTypes.VDP]: HollerWPVdpAssetWrapper
  };

  watchElements() {
    // Still observe page with mutation observer
    super.watchElements();

    const observer = new MutationObserver(() => {
      // This call could get ignored if a render call is already taking place
      void this.render();
    });

    if (this.pageType === PageTypes.SRP) {
      try {
        observer.observe(document.querySelector('.dms-srp__body .dms-srp__vehicle-card-wrapper')!, {
          subtree: false,
          childList: true
        });
      } catch (error) {
        this.eventBus.dispatchEvent(
          new OlWarning({ detail: { error, msg: '[HollerWP] Failed to setup renderingComplete handler' } })
        );
      }
    }
  }

  determinePageType(): PageTypes {
    if (window.document.querySelector('.dms-srp__body')) {
      return PageTypes.SRP;
    }
    if (window.document.querySelector('.dms-vdp__main-container')) {
      return PageTypes.VDP;
    }
    throw new PageNotReady('Render location not found in the container.');
  }

  getAssetContainers(): HTMLElement[] {
    let containers;
    if (this.pageType === PageTypes.SRP) {
      containers = Array.from<HTMLElement>(
        window.document.querySelectorAll('.dms-srp__vehicle-card-wrapper .dms-srp__vehicle-card')
      );
    } else if (this.pageType === PageTypes.VDP) {
      containers = Array.from<HTMLElement>(window.document.querySelectorAll('.dms-vdp__main-container'));
    } else {
      throw new Error('pageType is null or is not supported by this platform');
    }

    if (!(containers && containers.length)) {
      throw new PageNotReady('Containers not yet found');
    }
    return containers;
  }
}
